module.exports = __webpack_public_path__ + "static/media/ceres-logo-white.3c7d6180.svg";